import { memo } from 'react'

import { useFormatMessage } from '@acre/utils'
import type { SearchResultCase } from '@acre/graphql'

const _CaseSummary = ({
  activeCases,
  inactiveCases,
}: {
  activeCases: SearchResultCase[]
  inactiveCases: SearchResultCase[]
}) => {
  const formatMessage = useFormatMessage()
  const activeCount = activeCases.length
  const inactiveCount = inactiveCases.length
  if (activeCount === 0 && inactiveCount === 0) return null

  const summaryParts: string[] = []

  if (activeCount > 0) {
    summaryParts.push(formatMessage('search.activeCase', { count: activeCount }))
  }

  if (inactiveCount > 0) {
    summaryParts.push(formatMessage('search.historicalCase', { count: inactiveCount }))
  }

  return <span>{summaryParts.join(` ${formatMessage('generic.and').toLowerCase()} `)}</span>
}

const CaseSummary = memo(_CaseSummary)

export default CaseSummary
